'use strict'

import AppDispatcher from '../dispatcher/AppDispatcher';
import ChatConstants from '../constants/ChatConstants';
import ChatStore from '../stores/ChatStore';
import moment from 'moment';
import store from 'store';
import uuid from 'uuid';

export default {
    connect: function() {
        AppDispatcher.handleViewAction({actionType: ChatConstants.CHAT_CONNECT});
    },

    disconnect: function() {
        AppDispatcher.handleViewAction({actionType: ChatConstants.CHAT_DISCONNECT});
    },

    sendPrivateMessage: function(recipient, messageText, attachments) {
        AppDispatcher.handleViewAction({
            actionType: ChatConstants.CHAT_SEND_PRIVATE_MESSAGE,
            recipient, messageText, attachments,
        });
    },

    loadMessagesBefore: function(recipient, beforeId = null) {
        setTimeout(() => {
            AppDispatcher.handleViewAction({actionType: ChatConstants.CHAT_LOAD_BEFORE, recipient, beforeId});
        });
    },

    markChatAsRead: function(jid, type) {
        AppDispatcher.handleViewAction({actionType: ChatConstants.CHAT_MARK_AS_READ, jid, type});
    },

    updateChat: function(chat) {
        AppDispatcher.handleViewAction({actionType: ChatConstants.CHAT_UPDATE_CHAT, chat});
    },
    
    /**
     * Updates a bot message in the chat store
     * @param {string} messageType The type of message (prep-ahead or buy-sunbasket)
     * @param {string} messageText The content of the message
     * @param {boolean} isEmpty Whether the message is empty (no content)
     */
    updateFakeMessage: function(messageType, messageText, isEmpty = false) {
        const botJid = 'eatlove-prep-bot@chat.eatlove.is';

        // Get the chat thread for the prep bot
        const chat = ChatStore.getChatWithJid(botJid);

        // Create bot roster entry if it doesn't exist
        const roster = ChatStore.getRoster();
        let rosterItem = roster.find((item) => item.jid === botJid);
        if (!rosterItem) {
            roster.push({
                jid: botJid,
                nick: 'EatLove Prep',
                fake: true,
            });
        }

        // Set up the chat and flags
        chat.flags.fake = true;

        let newChatMessages = [];

        // Find existing message of this type
        let oldMessage = chat.messages.find(m => m.id === messageType);
        let prepAheadMarker = store.get('prep-ahead-read-marker');

        if (prepAheadMarker) {
            chat.markers.read = moment(prepAheadMarker);
        } else if (isEmpty) {
            chat.markers.read = moment();
        }
        
        // Set timestamp - use existing one if content hasn't changed
        let timestamp = chat.markers.read ? moment(chat.markers.read) : moment();
        if (messageText && oldMessage && oldMessage.messageText !== messageText) {
            timestamp = moment();
        }
        
        // Only add message if it has content
        if (messageText) {
            newChatMessages.push({
                id: messageType,
                from: botJid,
                to: ChatStore.whoami(),
                timestamp,
                link: messageType === 'buy-sunbasket' ? { href: '/groceries', text: 'Order your meals' } : null,
                messageText: messageText,
                attachments: [],
            });
        }

        chat.messages = newChatMessages;
        this.updateChat(chat);

        return chat;
    }
};
